import type { ReactNode } from 'react';

export const symbol_flip_camera_ios: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M634-445q-6 66-48.5 114T480-283q-10 0-19.5-1.5T441-288q-7-2-13.5-.5T416-282q-10 10-7.5 22.5T423-242q14 5 28.5 7t28.5 2q85 0 141.5-62T683-443l20 20q8 8 18 8.5t18-7.5q8-8 8-18t-8-18l-61-60q-9-9-21-9t-21 9l-60 60q-8 8-8 18t8 18q8 8 17.5 8t17.5-8l23-23Zm-355 15-20-20q-8-8-18-8t-18 8q-8 8-8 17.5t8 17.5l60 60q9 9 21.5 9t21.5-9l60-60q8-8 8-18t-8-18q-8-8-17.5-8t-17.5 8l-23 23q6-66 48.5-114T482-590q10 0 19.5 1.5T521-585q7 2 13.5.5T546-591q10-10 7.5-22.5T539-631q-14-5-28.5-7t-28.5-2q-85 0-141.5 62T279-430ZM140-120q-24 0-42-18t-18-42v-513q0-23 18-41.5t42-18.5h147l55-66q8-11 20-16t26-5h184q14 0 26 5t20 16l55 66h147q23 0 41.5 18.5T880-693v513q0 24-18.5 42T820-120H140Zm0-60h680v-513H645l-73-87H388l-73 87H140v513Zm340-257Z"
		/>
	</svg>
);
